import { keyBy, merge, values } from 'lodash';

import type { Entity } from '../../entities/index';
import type { TrackingContextValue } from '../../providers/TrackingContext';
import { getEntities } from '../../utils';

const mergeWithExistingTrackingEntities = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): Entity[] => {
  const existingEntities = getEntities(trackingContext);

  return values(merge(keyBy(existingEntities, 'schema'), keyBy(entities, 'schema')));
};

export const mergeWithTrackingContextValue = (
  trackingContext: TrackingContextValue,
  entities: Entity[]
): TrackingContextValue => ({
  ...trackingContext,
  entities: mergeWithExistingTrackingEntities(trackingContext, entities)
});
